import { Button, MenuItem, Select, Typography } from '@material-ui/core';
import { ColDef } from '@material-ui/data-grid';
import React, { useEffect, useState } from 'react'
import DataTable from '../../components/DataTable';
import api from '../../config/api'
import { Container } from './styles'
import { toast } from 'react-toastify'

interface User {
    id: number
    name: string
    email: string
    branch: number
    role_id: string
    role: Role
}
interface Role {
    id: number
    description: string
}

interface IFormatedUser {
    id: number
    name: string
    email: string
    branch: number
    role: string

}

function Users() {

    const [users, setUsers] = useState<User[]>([])
    const [formattedUsers, setFormattedUsers] = useState<IFormatedUser[]>([])
    const [selectedUsers, setSelectedUsers] = useState([])
    const [selectedRole, setSelectedRole] = useState<number>()


    useEffect(() => {
        async function fetch() {
            const response = await api.get<{ users: User[] }>('/users')
            setUsers(response.data.users)

            const auxFormattedUsers = response.data.users.map(user => {
                return {
                    ...user,
                    role: user.role ? user.role.description : 'Nenhum'
                }
            })
            setFormattedUsers(auxFormattedUsers)
        }
        fetch()
    }, [])

    const [roles, setRoles] = useState<Role[]>([])

    useEffect(() => {
        async function fetch() {
            const rolesResponse = await api.get<{ roles: Role[] }>('/roles')
            setRoles(rolesResponse.data.roles)
        }
        fetch()
    }, [])


    function handleSelectUser(ids: any) {
        setSelectedUsers(ids)
        console.log(ids)
    }

    async function handleSelectRole(event: React.ChangeEvent<{
        name?: string | undefined;
        value: unknown
    }>) {
        const id = Number(event.target.value)
        try {
            setSelectedRole(id)
        } catch (err) {
            console.log(err)
        }
    }

    async function handleUpdate() {
        try {

            const users = selectedUsers.map(id => { return { id } })

            await api.put('/users/roles', {
                users,
                role_id: selectedRole
            })
            console.log({
                users,
                role_id: selectedRole
            })
            toast.success('Permissões atualizadas com Sucesso!')
            window.location.reload();
        } catch (err) {
            toast.error('Erro ao tentar atualizar permissões!')
        }

    }

    const columns: ColDef[] = [
        { field: 'id', headerName: 'ID', width: 100 },
        { field: 'name', headerName: 'Nome', width: 300 },
        { field: 'email', headerName: 'Email', width: 300 },
        {
            field: 'branch_id',
            headerName: 'Agência',
            width: 100,
        },
        {
            field: 'role',
            headerName: 'Previlégio',
            width: 250
        }
    ];

    return (
        <Container>
            {
                selectedUsers.length > 0 &&
                <>
                    <Typography variant="h4" style={{ marginBottom: 10, fontWeight: 600 }} >
                        Alterar grupo de permissões dos usuários
                     </Typography>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            label="Grupo"
                            variant="outlined"
                            defaultValue={0}
                            style={{ width: 350 }}
                            onChange={(event) => {
                                handleSelectRole(event)
                                console.log(event.target.value)
                            }}
                        >
                            {
                                roles.map((role) =>
                                    <MenuItem key={role.id} value={role.id}>
                                        {role.description}
                                    </MenuItem>
                                )
                            }
                        </Select>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ height: 50, width: 150, marginLeft: 20 }}
                            onClick={handleUpdate}
                        >
                            Alterar Grupo
                        </Button>
                    </div>
                </>
            }

            <Typography variant="h4" style={{ marginBottom: 10, fontWeight: 600 }} >
                Lista de usuários
            </Typography>
            <DataTable columns={columns} rows={formattedUsers} check={true} handleSelected={handleSelectUser} />
        </Container>
    );
}

export default Users